import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import * as svc from "../../api/shadeService";
import { getApiErrorMessage } from "../../utils/apiError";

export const fetchShades = createAsyncThunk("shade/fetchAll", async (params) => {
  const res = await svc.getShades(params);
  return res.data;
});

export const createShadeThunk = createAsyncThunk("shade/create", async (data, { rejectWithValue }) => {
  try {
    const res = await svc.createShade(data);
    return res.data;
  } catch (err) {
    return rejectWithValue(getApiErrorMessage(err, "Failed to create shade."));
  }
});

export const updateShadeThunk = createAsyncThunk("shade/update", async ({ id, data }, { rejectWithValue }) => {
  try {
    const res = await svc.updateShade(id, data);
    return res.data;
  } catch (err) {
    return rejectWithValue(getApiErrorMessage(err, "Failed to update shade."));
  }
});

export const deleteShadeThunk = createAsyncThunk("shade/delete", async (id, { rejectWithValue }) => {
  try {
    await svc.deleteShade(id);
    return id;
  } catch (err) {
    return rejectWithValue(getApiErrorMessage(err, "Failed to delete shade."));
  }
});

const shadeSlice = createSlice({
  name: "shade",
  initialState: { list: [], loading: false, error: null },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchShades.pending, (state) => { state.loading = true; state.error = null; })
      .addCase(fetchShades.fulfilled, (state, action) => { state.loading = false; state.list = action.payload; })
      .addCase(fetchShades.rejected, (state, action) => { state.loading = false; state.error = action.error.message; })
      .addCase(createShadeThunk.fulfilled, (state, action) => { state.list.push(action.payload); })
      .addCase(updateShadeThunk.fulfilled, (state, action) => {
        const id = action.payload.shadeID || action.payload.id;
        const idx = state.list.findIndex((s) => (s.shadeID || s.id) === id);
        if (idx !== -1) state.list[idx] = action.payload;
      })
      .addCase(deleteShadeThunk.fulfilled, (state, action) => {
        state.list = state.list.filter((s) => (s.shadeID || s.id) !== action.payload);
      });
  },
});

export default shadeSlice.reducer;
